import * as React from "react";
//import PropTypes from "prop-types";
import {
  Dialog,
  Button,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  DialogTitle,
} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SimpleDialog(props) {
  const { onClose, dialog, open } = props;
  let image = "";

  if (dialog === "On a gagné la manche") {
    image = <img src="../img/money-cash.gif" alt="win"></img>;
  } else if (dialog === "On a perdu la manche") {
    image = <img src="../img/loser.gif" alt="lose"></img>;
  } else if (dialog === "fais pas le con") {
    image = <img src="../img/no.png" alt="lose"></img>;
  }
  return (
    <>
      <Dialog
        style={{ textAlign: "center", justifyContent: "center" }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <span className="dialogText">{dialog}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <span className="dialogImg">{image}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ textAlign: "center", justifyContent: "center" }}
        >
          <Button onClick={onClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
